import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "element-plus/dist/index.css"
import "element-plus/theme-chalk/dark/css-vars.css"
import vue3SeamlessScroll from "vue3-seamless-scroll"

createApp(App).use(store).use(router).use(ElementPlus).use(vue3SeamlessScroll).mount('#app')
